import { CONFIG_LS_UPDATE } from './types';
const initialState = {
  adultAges: {},
  i18n: {
    allowList: [],
    fallBacks: {
      default: ['en-US']
    }
  },
  countries: [],
  documents: {
    hipaadoc: {},
    pnpat: {},
    privacypolicy: {},
    toufsll: {},
    toupat: {},
    hipaa: {}
  },
  documentsUrl: '',
  languages: [],
  libreSharingApiUrl: '',
  partners: {},
  sharingWebviewsUrl: '',
  supportedCountries: [],
  validation: {
    identity: [],
    libreSharingApi: {
      patient: {
        firstName: {
          stringMaxLength: 0
        },
        lastName: {
          stringMaxLength: 0
        }
      }
    }
  },
  webviewsUrl: '',
  lvapiURL: '',
  libreApiCountryUrls: {},
  libreSharingApiCountryUrls: {},
  lvApiCountryUrls: {},
  zipCodePatterns: {},
  regions: {}
};
export const lsConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG_LS_UPDATE:
      return {
        ...state,
        ...action.lsConfig
      };
    default:
      return state;
  }
};